export function registerServiceWorker(): void {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  const register = () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Регистрацията е best-effort - сайтът работи и без service worker.
    });
  };

  if (document.readyState === 'complete') {
    register();
  } else {
    window.addEventListener('load', register, { once: true });
  }
}
